<template>
  <div>
    <p class="font-weight-bold mt-6 px-8">
      Försenade tåg
    </p>

    <TrafficMessageRow :items="list" />
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
import TrafficMessageRow from './TrafficMessageRow'
import diffFactory from '@/helpers/diffFactory'

export default {
  name: 'TrafficMessageDelayTrainsText',

  components: {
    TrafficMessageRow
  },

  computed: {
    delays: get('delay/data'),
    model: get('trafficMessage/model'),
    stops: get('event/stops'),

    list() {
      const findLocationName = signature => {
        const location = this.stops.find(
          x => x.short_name === signature.toUpperCase()
        )
        return location ? location.stop_name : signature.toUpperCase()
      }

      const delays = diffFactory(
        this.model.delays,
        x =>
          `Försening, ${x.train_number} ${findLocationName(
            x.location_place
          )}, ${x.delay}min`,
        this.delays
      )

      return delays
    }
  }
}
</script>
